const InfiniteScroll = require('infinite-scroll');

const bindAjaxLoader = ($el) => {
    let currentPage = 1;
    let elClass = `.${$el.attr('class')}`;

    let _instance = new InfiniteScroll($el.data('target'), {
        path: elClass,
        append: $el.data('item'),
        history: false,
        scrollThreshold: false,
        button: '.load-posts',
        checkLastPage: true
    });

    _instance.on('request', () => $el.addClass('loading'));

    _instance.on('append', () => {
        $el.removeClass('loading');

        currentPage++;

        if ($el.data('max') && currentPage === parseInt($el.data('max'))) {
            $el.hide();
        }
    });
};

export { bindAjaxLoader };



// WEBPACK FOOTER //
// ./resources/assets/js/views/News.js